import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { addErrorNotification, addSuccessNotification, loadLoyaltyMasterData, logger, NotificationType } from '@vista-digital/occ-domain';
import { useMountEffect } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { forwardRef, useContext } from 'react';
import { getIdForComponentNotification } from '../../utils/get-id-for-component-notification';
import { Form } from '../form/form/form';
import { MemberFormContextInstance } from './types/context';
const b = bemClassBuilder('v-member-form');
const MemberFormBase = (props, ref) => {
    const { clearValidationErrors, formId, getNotificationDetailsForError } = props;
    const { formData, setFormData, config, displayText, events, assets, validator } = useContext(MemberFormContextInstance);
    useMountEffect(() => {
        clearValidationErrors();
        loadLoyaltyMasterData().catch(() => {
            logger.error('Could not load loyalty master data.');
        });
        return clearValidationErrors;
    });
    const handleFailedSubmit = (error) => {
        var _a;
        (_a = events.onAfterFailedSubmit) === null || _a === void 0 ? void 0 : _a.call(events, error);
        addErrorNotification(getNotificationDetailsForError(error), error);
    };
    const handleSuccessfulSubmit = async () => {
        var _a;
        await ((_a = events.onAfterSuccessfulSubmit) === null || _a === void 0 ? void 0 : _a.call(events));
        addSuccessNotification({
            id: getIdForComponentNotification('member-form', NotificationType.Success, 'submit'),
            messages: [displayText.formSubmittedMessage]
        });
    };
    return (_jsx(Form, { id: formId, className: b.block(), validator: () => validator.validateForm(formData), config: config, events: Object.assign(Object.assign({}, events), { onAfterFailedSubmit: handleFailedSubmit, onAfterSuccessfulSubmit: handleSuccessfulSubmit }), displayText: displayText, assets: assets, setFormData: setFormData, ref: ref, children: props.children }));
};
/**
 * The **MemberForm** is a generic subcomponent that can be wrapped for different types of Member Form components.
 */
export const MemberForm = observer(forwardRef(MemberFormBase));
MemberForm.displayName = 'MemberForm';
//# sourceMappingURL=member-form.js.map